// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "97120/static/css/" + chunkId + "." + {"591":"d68d36c5","707":"c4dfc447","1566":"688aa26f"}[chunkId] + ".chunk.css";
};